// extracted by mini-css-extract-plugin
export var cancelButton = "_ol-5";
export var content = "_ol-3";
export var createButton = "_ol-6";
export var drawerContainer = "_ol-0";
export var footer = "_ol-2";
export var header = "_ol-1";
export var orderFormColumn = "_ol-4";